import { useTranslation } from "react-i18next";
import { InvoicingTypeEnum } from "../api/models/companyInvoicingType.models";

export const useInvoicingTypeItems = () => {
  const { t } = useTranslation();

  return [
    {
      name: t("label-invoicing-type-year-estimate-quarterly"),
      value: InvoicingTypeEnum.YEAR_ESTIMATE_QUARTERLY,
    },
    {
      name: t("label-invoicing-type-year-estimate-monthly"),
      value: InvoicingTypeEnum.YEAR_ESTIMATE_MONTHLY,
    },
    {
      name: t("label-invoicing-type-quarterly"),
      value: InvoicingTypeEnum.QUARTERLY,
    },
    {
      name: t("label-invoicing-type-monthly"),
      value: InvoicingTypeEnum.MONTHLY,
    },
    {
      name: t("label-invoicing-type-yearly"),
      value: InvoicingTypeEnum.YEARLY,
    },
  ];
};
